import { Breadcrumb } from 'semantic-ui-react';

export default Breadcrumb;
